import { render } from "./GoalsMetricReport.vue?vue&type=template&id=68499629&ts=true"
import script from "./GoalsMetricReport.vue?vue&type=script&lang=ts"
export * from "./GoalsMetricReport.vue?vue&type=script&lang=ts"

import "./GoalsMetricReport.vue?vue&type=style&index=0&id=68499629&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__